import { Route } from 'react-router-dom';
import { MANAGE_DOCUMENT_TEMPLATES_ROUTES } from './ManageDocumentTemplates.routes';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry.ts';
import { DocumentTemplatesTable } from '@dealstack/frontend/app/pages/DocumentTemplates/DocumentTemplatesTable/DocumentTemplatesTable.tsx';
import { CreateDocumentTemplate } from '@dealstack/frontend/app/pages/DocumentTemplates/CreateDocumentTemplate/CreateDocumentTemplate.tsx';
import { EditDocumentTemplate } from '@dealstack/frontend/app/pages/DocumentTemplates/EditDocumentTemplate/EditDocumentTemplate.tsx';
import { Wrapper } from './ManageDocumentTemplates.styled';

export const ManageDocumentTemplates = () => {
	return (
		<Wrapper>
			<SentryRoutes>
				<Route
					path={MANAGE_DOCUMENT_TEMPLATES_ROUTES.CREATE}
					element={<CreateDocumentTemplate />}
				/>
				<Route
					path={MANAGE_DOCUMENT_TEMPLATES_ROUTES.EDIT}
					element={<EditDocumentTemplate />}
				/>

				<Route path="*" element={<DocumentTemplatesTable />} />
			</SentryRoutes>
		</Wrapper>
	);
};
